import React from 'react'
import { css } from 'aphrodite'

import style from '../style'

export const Icon = ({ children, ...rest }) => {
  return (
    <span className={`${css(style.icons.icon)} material-icons`} {...rest}>
      {children}
    </span>
  )
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/partials/Editor/partials/Icon.js